import React from "react";

export const ProductGridSkeleton = ({ count = 8 }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white rounded-xl border border-[#E5E7EB] overflow-hidden animate-pulse">
        <div className="aspect-square bg-[#DCE7E2]" />
        <div className="p-3 space-y-2">
          <div className="h-3 bg-[#F6F7F4] rounded w-3/4" />
          <div className="h-4 bg-[#F6F7F4] rounded w-1/2" />
          <div className="h-3 bg-[#F6F7F4] rounded w-1/3" />
        </div>
      </div>
    ))}
  </div>
);

export const EmptyState = ({ message, testId = "empty-state" }) => (
  <div data-testid={testId} className="flex flex-col items-center justify-center py-16 text-center">
    <div className="w-16 h-16 rounded-full bg-[#DCE7E2] flex items-center justify-center mb-4 text-2xl">
      🧺
    </div>
    <p className="text-[#6B7280] max-w-xs">{message}</p>
  </div>
);
